import { Box, Container, Stack } from '@mui/material';
import { Seo } from 'src/components/seo';
import { DetailForm } from './detail-form';
import { useTranslation } from 'react-i18next';
import BackNavigation from 'src/components/ui/headers/title-back';
import useForms from 'src/api/sessions/vm-form';
import useToast from 'src/utils/toast-utils';

const Page = (props) => {
  const { t } = useTranslation();
  const { onNavigate, item } = props;
  const { insertItem, updateItem, deleteItem } = useForms();
  const { toastSuccess, toastError } = useToast();

  // Add new item
  const apiCreate = async (values) => {
    await insertItem(
      values,
      (result) => {
        toastSuccess(`Đã thêm ${result}`, {action: 'back'});
      },
      (error) => {
        toastError(error);
      },
    );
  };

  // Update item
  const apiUpdate = async (values) => {
    await updateItem(
      values,
      (result) => {
        toastSuccess(`Đã sửa ${result}`, {action: 'back'});
      },
      (error) => {
        toastError(error);
      },
    );
  };

  // Update item
  const apiDelete = async (values) => {
    await deleteItem(
      values,
      (result) => {
        toastSuccess(`Đã xóa ${result}`, {action: 'back'});
      },
      (error) => {
        toastError(error);
      },
    );
  };

  return (
    <>
      <Seo title="Session Detail" />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 0.5,
        }}
      >
        <Container maxWidth="xl">
          <Stack spacing={1}>
            <BackNavigation
              onBackClick={onNavigate}
              label={'Tổng quan'}
            />
            <Stack>
              <DetailForm
                item={item}
                apiCreate={apiCreate}
                apiUpdate={apiUpdate}
                apiDelete={apiDelete}
              />
            </Stack>
          </Stack>
        </Container>
      </Box>
    </>
  );
};

export default Page;
